import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},

    summaryContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 24,
        flex: '1 0 0',
        alignSelf: 'stretch',
        // height: 'calc(100vh - 230px)',
        // maxHeight: 'calc(100vh - 230px)',
        minHeight: 0,
        overflow: 'auto',
    },

    summaryHeader:{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '16px',
        alignSelf: 'stretch',
        flex: '0 0 auto',
    },
    summaryItem:{
        display: 'flex',
        minWidth: 0,
        flex: '1 1 220px',
        padding: '8px',
        alignItems: 'center',
        gap: '16px',
        alignSelf: 'stretch',
        backgroundColor: theme.colors.surface_elevated,
        borderRadius: '4px',
        border: `1px solid ${theme.colors.grey_light}`,
    },
    summaryImageContainer:{
        display: 'flex',
        width: '64px',
        padding: '4px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        flexShrink: '0',
        alignSelf: 'stretch',

        backgroundColor: `${theme.colors.grey_light}`,
        borderRadius: '2px',
    },
    summaryItemImage:{
        width: '32px',
        height: '32px',
        flexShrink: '0',
        aspectRatio: '1/1',
        filter: theme.isDark ? 'brightness(0) invert(1)' : 'none',
    },
    summaryItemMonogram: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: '50%',
        backgroundColor: theme.colors.violet_primary,
        color: '#ffffff',
        fontSize: 13,
        fontWeight: 700,
        letterSpacing: 0.5,
        userSelect: 'none',
        flexShrink: 0,
        fontFamily: theme.font.primary,
    },
    summaryTextContainer:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        flex: '1 0 0',
        minWidth: 0,
    },
    summaryTitle:{
        color: `${theme.colors.text_heading}`,
        fontFamily: theme.font.primary,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: 'normal',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    summaryValue:{
        color: `${theme.colors.text_heading}`,
        fontFamily: theme.font.primary,
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: 1.15,
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },

    loader: {
        color: theme.colors.violet_primary,
    },

    [theme.down('tablet')]: {
        summaryContainer: {
            height: 'calc(100dvh - 230px)',
            maxHeight: 'calc(100dvh - 230px)',
            fallbacks: [
                { height: 'calc(100vh - 230px)' },
                { maxHeight: 'calc(100vh - 230px)' },
            ],
        },
        // Keep the stat cards to a single compact, horizontally-scrollable row
        // so they stop consuming the vertical space the graph needs.
        summaryHeader: {
            flexWrap: 'nowrap',
            overflowX: 'auto',
            gap: '8px',
            paddingBottom: '4px',
            WebkitOverflowScrolling: 'touch',
        },
        summaryItem: {
            flex: '0 0 auto',
            minWidth: 150,
            padding: '6px',
            gap: '10px',
        },
        summaryValue: {
            fontSize: '18px',
        },
        summaryImageContainer: {
            width: '44px',
        },
    },
}));
